import { useDispatch } from "react-redux";
import { enumStatuses, OPEN, statuses as statusesPO } from "../../consts/status";
import { upsertPO } from "../../slices/purchasesOrdersSlice";
import { useEffect, useState } from "react";
import { InformationCircleIcon, PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { SaveCancelButtons } from "../SaveCancelButtons";
import { ROUTES } from "../../consts/general";
import { SelectDropdown } from "../SelectDropdown";
import PurchaseOrderStatusChip from "../../features/purchaseOrders/PurchaseOrderStatusChip";

export const POSidebarHeader = ({
    editStatus,
    openTheStatusSelect,
    access,
    searchValue,
    currentStatuses,
    poPage,
    poItemsPerPage,
    currentPO,
    onClose,
    testId
}) => {

    const dispatch = useDispatch();
    const oldPOStatus = currentPO.status;
    const poNumber = currentPO.poNumber || "PO";
    const hasShipment = currentPO.hasShipment;

    const [poStatus, setPOStatus] = useState(currentPO.status)

    useEffect(() => {
        if (editStatus && !poStatus) {
            setPOStatus(OPEN)
        }
    }, [editStatus])


    useEffect(() => {
        if (testId) return
        setPOStatus(currentPO.status)
    }, [currentPO])

    const statusOptions = statusesPO.map(status => ({
        value: status,
        label: enumStatuses[status]
    }));

    return (
        <section>
            <div className="flex justify-between items-center">
                <div className="flex items-center space-x-3" data-testid={testId}>
                    <h2 className="text-xl font-bold tracking-tight">
                        {hasShipment 
                            ? (
                                <a href={`${ROUTES.SHIPPING}?search=${currentPO.poNumber}#${currentPO.id}`} target="_blank" className="text-gray-900">
                                    {poNumber}
                                </a>
                            )
                            : poNumber
                        }
                    </h2>
                    <div className="relative flex gap-2 items-center">
                        {!editStatus && (
                            <>
                                <PurchaseOrderStatusChip
                                    status={poStatus}
                                />
                                {access === "edit" && (
                                     <PencilSquareIcon className="h-4 w-4 cursor-pointer" aria-hidden="true" onClick={() => openTheStatusSelect(true)} />
                                )}
                            </>
                        )}
                        {editStatus && (
                            <div className="w-[120px]">
                                <SelectDropdown
                                    options={statusOptions}
                                    value={poStatus}
                                    onChange={setPOStatus}
                                    selectClassname="!w-auto !border-none !bg-transparent !p-0"
                                    isStatuses={true}
                                    testId={testId ? `${testId}-status-select` : undefined}
                                />
                            </div>
                        )}
                    </div>
                    {editStatus && access === "edit" && (
                        <SaveCancelButtons 
                            testId={testId}
                            saveOnClick={async () => {
                                if (testId) {
                                    console.log("clicked save button")
                                    return
                                }
                                if (oldPOStatus !== poStatus) {
                                    await dispatch(upsertPO({ 
                                        po: {
                                            ...currentPO,
                                            status: poStatus || statusesPO[0],
                                        },
                                        search: searchValue, 
                                        statuses: currentStatuses, 
                                        page: poPage,
                                        itemsPerPage: poItemsPerPage
                                    }));
                                }
                                openTheStatusSelect(false)
                            }}
                            cancelOnClick={() => {
                                if (testId) {
                                    console.log("clicked cancel button")
                                    return
                                }
                                openTheStatusSelect(false)
                                setPOStatus(oldPOStatus)
                            }}
                        />
                    )}
                </div>
                <div className="flex flex-col items-center justify-center gap-1">
                    <button onClick={onClose} className="p-1.5 rounded-md text-gray-500 hover:bg-gray-100 transition-colors" aria-label="Close details">
                        <XMarkIcon className="h-4 w-4" />
                    </button>
                    <a 
                        className="text-gray-400 hover:text-gray-500"
                        href={`${ROUTES.NOTES}#accounts-payable-operating-standard`} 
                        target="_blank"
                    >
                        <InformationCircleIcon className="h-5 w-5 text-blue-600" />
                    </a>
                </div>
            </div>
            {currentPO?.productGroupsByPO && (
                <>
                    <p className="mt-0.5 text-sm font-semibold">
                        {currentPO.productGroupsByPO}
                    </p>
                    {currentPO?.rangeActualDate && (
                        <div className>Date Received <span className="text-base px-3 py-1 rounded-xl bg-[#dcfce6] text-black">{currentPO.rangeActualDate}</span></div>
                    )}
                </>
            )}
        </section>
    )
}